// Which app sends a request, for the admin console's numbers (X-Client-Platform header):
// the phone apps (Capacitor), the desktop app (Electron) or a browser.
import { platform } from '../native/platform';
import { isDesktop } from '../native/desktop';

export const clientPlatform = () => {
  if (isDesktop()) return 'desktop';
  const p = platform();
  return p === 'ios' || p === 'android' ? p : 'web';
};
